<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mb-2 mt-sm-0">
      <v-flex xs12 sm8 md4 lg6>
        <h4 class="dark--text font-weight-bold">Additional Payment History</h4>
      </v-flex>
    </v-layout>

    <v-layout class="mt-6 ms-n5 ps-5 ps-sm-0" wrap>
      <v-flex xs8 sm3 md3 lg2 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <v-select :items="fieldsToSearch" v-model="fieldToSearch" item-text="key" item-value="value" label="Field To Search" dense attach solo></v-select>
      </v-flex>
      <v-flex xs8 sm3 md1 lg2 class="ml-2">
        <v-text-field placeholder="Search.." v-model="search" solo dense> </v-text-field>
      </v-flex>
      <v-flex xs8 sm3 md3 lg2 class="mt-5 mt-sm-0 ms-sm-5 me-5">
        <v-select :items="paymentMethods" v-model="paymentMethod" clearable chips label="Payment method" dense attach solo></v-select>
      </v-flex>

      <v-flex xs8 sm3 md1 lg3 class="ml-2">
        <v-btn class="ms-sm-5 light--text text-capitalize" color="primary" width="150" @click="listAllAdditionalPayments">Search </v-btn>
      </v-flex>
    </v-layout>

    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="payments"
      class="elevation-1"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalItems"
      :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
    >
      <template #item.createdAt="{ item }">{{ new Date(parseInt(item.createdAt)) | moment("MMM DD YYYY") }} </template>
      <template #item.price="{ item }">{{ numberWithCommas(item.price) }} </template>
      <template #item.discount="{ item }">{{ numberWithCommas(item.discount) }} </template>
      <template #item.netPrice="{ item }">{{ numberWithCommas(item.netPrice) }} </template>
      <template #item.phone="{ item }">{{ item.customer.user.phone }} </template>
      <template #item.additionalMeals="{ item }">
        <AdditionalMeals :additionalMeals="item.additionalMeals" />
      </template>
      <template #item.createdBy="{ item }">
        <span v-if="item.createdBy">
          {{ item.createdBy.firstnameEn }}
          {{ item.createdBy.lastnameEn }}
        </span>
      </template>

      <template v-slot:[`item.customer`]="{ item }">
        <router-link
          v-if="item.customer.user"
          :to="{
            name: 'CustomerDetails',
            query: { customerId: item.customer._id },
          }"
          class="mx-auto"
        >
          {{ capitalizeFirstLetter(item.customer.user.firstnameEn) }}
          {{ capitalizeFirstLetter(item.customer.user.lastnameEn) }}
        </router-link>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import AdditionalMeals from "../components/AdditionalMeals.vue";
export default {
  components: { AdditionalMeals },

  created() {
    this.listAllAdditionalPayments();
  },

  watch: {
    options: {
      handler() {
        this.listAllAdditionalPayments();
      },
      deep: true,
    },
  },
  methods: {
    listAllAdditionalPayments() {
      this.loading = true;
      this.$apollo
        .watchQuery({
          query: require("../api/listAllAdditionalPayments.graphql"),
          variables: {
            limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
            skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,
            fieldToSearch: this.fieldToSearch,
            searchKey: this.search,
            paymentMethod: this.paymentMethod,
          },
        })
        .refetch({
          variables: {
            limit: this.options.itemsPerPage !== -1 ? this.options.itemsPerPage : 200,
            skip: this.options.page * this.options.itemsPerPage - this.options.itemsPerPage,

            fieldToSearch: this.fieldToSearch,
            searchKey: this.search,
            paymentMethod: this.paymentMethod,
          },
        })
        .then(data => {
          this.loading = false;

          if (data.data.listAllAdditionalPayments) {
            this.payments = data.data.listAllAdditionalPayments.subscriptionSupplementPayment;
            this.totalItems = data.data.listAllAdditionalPayments.totalCount;
          }
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
  },

  data: () => ({
    loading: true,
    totalItems: 0,
    paymentMethods: [
      { text: "Online", value: "ONLINE" },
      { text: "Offline", value: "OFFLINE" },
      { text: "Free", value: "FREE" },
    ],
    paymentMethod: "",
    fieldToSearch: "PHONE",
    fieldsToSearch: [
      { key: "Customer Id", value: "CUSTOMER_ID" },
      { key: "Customer Name", value: "CUSTOMER_NAME" },
      { key: "Contact Number", value: "PHONE" },
    ],
    search: "",
    show_dialog_box: false,
    payments: [],
    options: {
      itemsPerPage: 25,
      page: 1,
    },

    headers: [
      { text: "Customer", value: "customer", sortable: false },
      { text: "Phone", value: "phone", sortable: false },
      {
        text: "Date",
        value: "createdAt",
        sortable: false,
      },
      { text: "Additional Meals", value: "additionalMeals", sortable: false },
      { text: "Additional Payment", value: "price", sortable: false },
      { text: "Discount", value: "discount", sortable: false },
      { text: "Net Price", value: "netPrice", sortable: false },
      { text: "Payment Method", value: "paymentMethod", sortable: false },
      { text: "Created By", value: "createdBy", sortable: false },
    ],
  }),
};
</script>
<style>
.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0.2 !important;
}
</style>
